import React from 'react';
import { useConfigContext } from 'common/components/CopyMagic/contexts';
import ConversationAssistantDrawerV2 from '../ConversationAssistantDrawerV2';
import ConversationAssistantFullscreen from '../ConversationAssistantFullscreen';

const ConversationAssistantV2 = () => {
  const { fullscreen } = useConfigContext();

  if (fullscreen) {
    return <ConversationAssistantFullscreen />;
  }

  return <ConversationAssistantDrawerV2 />;
};

export default ConversationAssistantV2;
